import { ChangeEvent, ReactNode, useId } from 'react';

import {
  TabSwitcherTabInput,
  TabSwitcherTabLabel,
} from './TabSwitcherTab.styles';

type Props = {
  name: string;
  isSelected: boolean;
  children: ReactNode;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  compact: boolean;
  qaId?: string;
};

export function TabSwitcherTab({
  name,
  isSelected,
  children,
  onChange,
  compact,
  qaId,
}: Props) {
  const id = `tab-switcher-tab-${useId()}`;

  return (
    <>
      <TabSwitcherTabInput
        id={id}
        type="radio"
        name={name}
        checked={isSelected}
        onChange={onChange}
      />

      <TabSwitcherTabLabel
        htmlFor={id}
        $compact={compact}
        data-qa-id={qaId}
        aria-selected={isSelected}
      >
        {children}
      </TabSwitcherTabLabel>
    </>
  );
}
